/* eslint-disable import/no-unused-modules */
import React, { useEffect } from 'react';

import { makeNamespacedComponent } from '@/ui/utils';
import { RootStyled } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/variants/styles';
import { WeeklyLearningLoop } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/types';
import {
  WeeksPagination,
  WeeksTabNavigation,
  LoadingState,
} from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/atoms';
import { useWeekNavigationsContext } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/context';

type EndedWeeksSetupProps = {
  weeks: WeeklyLearningLoop[];
  selectedWeek: WeeklyLearningLoop | null;
  maxVisibleWeeksCount?: number;
  onChangeSelectedWeek: (weekNumber: number) => void;
};

const EndedWeeksSetupBase = ({
  weeks,
  maxVisibleWeeksCount = 4,
  selectedWeek,
  onChangeSelectedWeek,
}: EndedWeeksSetupProps): JSX.Element => {
  const { setWeeks, setMaxVisibleWeeksCount, setSelectedWeek, triggeredPagination, shownWeeks } = useWeekNavigationsContext();

  useEffect(() => {
    setWeeks(weeks);
    setMaxVisibleWeeksCount(maxVisibleWeeksCount);
    setSelectedWeek(selectedWeek);
  }, [weeks, maxVisibleWeeksCount, selectedWeek]);

  const isSelectedWeekVisible = shownWeeks.map(({ id }) => id).includes(selectedWeek?.id || '');

  if (!triggeredPagination && !isSelectedWeekVisible) {
    return <LoadingState />;
  }

  return (
    <RootStyled>
      <WeeksPagination>
        <WeeksTabNavigation onChangeSelectedWeek={onChangeSelectedWeek} showProgressLabel showSelectedStyling={false} />
      </WeeksPagination>
    </RootStyled>
  );
};

const EndedWeeksSetup = makeNamespacedComponent(EndedWeeksSetupBase, {
  LoadingState,
});

export { EndedWeeksSetup };
